export const getSiteLanesQueryKey = (siteId: string) => ['siteLanes', siteId];

export const getLaneDetailQueryKey = (locationId: number, laneId: number) => [
  'lane-detail',
  locationId,
  laneId,
];

export const getLaneGateDetailQueryKey = (locationId: number, laneId: number) => [
  'lane-gate-detail',
  locationId,
  laneId,
];

export const getLaneGateAccessQrQueryKey = (siteId: number, laneId: number) =>
  ['lane-gate-access-qr', siteId, laneId] as const;

export const getLocationDoorsQueryKey = (locationId: number) =>
  ['locationDoors', locationId] as const;

export const getLocationLaneDevicesQueryKey = (locationId: number) => ['laneDevices', locationId];
